import { FC, lazy } from 'react';

import { Patients } from '@/modules/patients';

export const PatientsPage: FC = () => <Patients />;

export const PatientsPageLazy = lazy(async () => {
    const { PatientsPage } = await import('./page');

    return { default: PatientsPage };
});
